// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as zod from "zod";

export const addPreAuthFormSchema = zod.object({
  // merchantId: zod.string(),
  merchantId: zod.number().int().nonnegative(),
  cardHolderName: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  cardNumber: zod
    .preprocess((val) => String(val).replaceAll('_', '').trim(), zod.string().min(1, { message: "Please enter your phone number" })),
  lastUsingDate: zod.preprocess((val) => String(val).replaceAll('_', '').replaceAll('/', '').trim(), zod.string().min(1, { message: "Please enter your phone number" })),
  cvv: zod.string().min(3, { message: "Please enter your phone number" }).max(4),
  totalAmount: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  // installmentCount: zod
  //   .string()
  //   .min(1, { message: "Please enter your phone number" }),
  installmentCount: zod.any(),
  commissionParameterId: zod.any(),
  // currency: zod.string().min(1, { message: "Please enter your phone number" }),
  currency: zod.any(),
  // orderId: zod.string().min(1, { message: "Please enter your phone number" }),
  orderId: zod
  .preprocess((val) => String(val).replace(/\s/g, '').trim(), zod.string().min(1, { message: "Please enter your phone number" })),

  use3D: zod.string().min(1, { message: "Please enter your phone number" }),
});

export type PreAuthAddFormValuesType = zod.infer<typeof addPreAuthFormSchema>;

export const initialPreAuthState: PreAuthAddFormValuesType = {
  merchantId: "",
  cardHolderName: "",
  cardNumber: "",
  lastUsingDate: "",
  cvv: "",
  totalAmount: "",
  installmentCount: "",
  currency: "",
  orderId: "",
  use3D: "",
  commissionParameterId: 0
};
